'use strict';

/**
 * Общие праздники (серверные списки праздников)
 */
Fotobook.holidays.common = {
    getDate(date) {
        let holiday = null;
        const lists = Fotobook.store.getters['OnlineEditor/holidayLists'];

        for (let i = 0, l = lists.length; i < l; i++) {
            const list = lists[i];
            let binding;

            const bindings = Fotobook.store.getters['ProjectState/holidayListsBinding'];
            if (!list.active || !(binding = bindings[list.id]) || !binding.active) {
                continue;
            }

            holiday = list.filter.getDate(date);
            if (holiday) {
                holiday = $.extend({}, holiday);
                // eslint-disable-next-line camelcase
                holiday.date_style = holiday.date_style || binding.date_style || list.date_style;
                break;
            }
        }
        return holiday;
    },
};
